import React from 'react';

export default function HelpOnboarding({ className, open }) {
  return (
    <section className={className}>
      {open ? (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="#F2F4F7" />
          <path
            d="M18.5 18.5L31.5001 31.5001"
            stroke="#E60000"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.5 18.5L18.4999 31.5001"
            stroke="#E60000"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="#F2F4F7" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.988 11.9566C20.2588 11.9497 15.8983 14.5118 13.5988 18.6482C11.2993 22.7847 11.423 27.8444 13.9217 31.8634C13.9217 31.8634 14.6552 32.9258 15.8692 34.141C17.0833 35.3562 18.1301 36.0758 18.1301 36.0758C22.8288 39.0011 28.8608 38.6371 33.1743 35.1679C37.4879 31.6986 39.1421 25.8808 37.3 20.6579C35.458 15.435 30.5214 11.9462 24.988 11.9566Z"
            stroke="#E60000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.7116 29.9878C24.4815 29.9878 24.2949 30.1743 24.2949 30.4045C24.2949 30.6346 24.4815 30.8211 24.7116 30.8211C24.9417 30.8211 25.1283 30.6346 25.1283 30.4045C25.1283 30.1743 24.9417 29.9878 24.7116 29.9878"
            stroke="#E60000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.377 23.0433C21.377 21.2023 22.8693 19.71 24.7103 19.71C26.5512 19.71 28.0436 21.2023 28.0436 23.0433C28.0436 24.8842 26.5512 26.3766 24.7103 26.3766"
            stroke="#E60000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </section>
  );
}
